import React from "react";
import { Group, Line, Text } from "react-konva";
import { mapPointToCanvas } from "../../trackTrace/mapUtils";
import { TrackTraceFloorMap, TrackTraceZone } from "../../trackTrace/types";

interface Props {
    zones: TrackTraceZone[];
    floorMap: TrackTraceFloorMap;
    selectedZoneId?: number | null;
    onSelectZone: (zone: TrackTraceZone) => void;
}

const ZonePolygonLayer: React.FC<Props> = ({ zones, floorMap, selectedZoneId, onSelectZone }) => {
    return (
        <Group>
            {zones.map((zone) => {
                const points = zone.polygon.flatMap((point) => {
                    const canvasPoint = mapPointToCanvas(point, floorMap);
                    return [canvasPoint.x, canvasPoint.y];
                });
                if (points.length < 4) return null;
                const labelPoint = mapPointToCanvas(zone.polygon[0], floorMap);

                return (
                    <Group key={zone.id} onTap={() => onSelectZone(zone)} onClick={() => onSelectZone(zone)}>
                        <Line
                            points={points}
                            closed
                            fill={selectedZoneId === zone.id ? 'rgba(14, 165, 233, 0.24)' : 'rgba(14, 165, 233, 0.12)'}
                            stroke={selectedZoneId === zone.id ? '#0284c7' : '#38bdf8'}
                            strokeWidth={selectedZoneId === zone.id ? 4 : 3}
                            strokeScaleEnabled={false}
                            lineJoin="round"
                        />
                        <Text x={labelPoint.x + 6} y={labelPoint.y + 6} text={zone.name || ''} fontSize={13} fill="#075985" />
                    </Group>
                );
            })}
        </Group>
    );
};

export default ZonePolygonLayer;
